import Resource from '@/api/resources/Resource'

class ClinicalSubrequestPrintService extends Resource {
    async generateLabelsWithCopiesNumber(labId, requestId, subrequestsWithCopiesMap) {
        return this.axios.put(`/clinical/laboratories/requests/${requestId}/generateLabelsWithCopies`,
            subrequestsWithCopiesMap,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    laboratoryId: labId
                },
                responseType: 'arraybuffer'
            }
        ).then(response => response.data)
    }
}

export default new ClinicalSubrequestPrintService()
